export class Expense {
  monto: number;
  descripcion: string;
  user_id: number;
}
